<template>
  <c-checkbox
    v-bind="$attrs"
    @mouseenter.native="$emit('mouseenter')"
    @mouseleave.native="$emit('mouseleave')"
    v-on="$listeners"
  />
</template>

<script>
import CCheckbox from '@convenia/components/CCheckbox'

export default {
  components: { CCheckbox },

  name: 'CFragmentCheckbox',
}
</script>
